export const videoFormats = (format) => [
  'video/mp4',
  'video/webm',
].includes(format);
